module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.testRoute()) ? _c('div', {
    staticClass: "slogan-bar"
  }, [_c('router-link', {
    staticClass: "slogan-bar__logo",
    attrs: {
      "to": "/",
      "tag": "button"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f66edd9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/HeaderBar.vue
// module id = 595
// module chunks = 2